import { DEFAULT_INTERVAL_CONFIG } from "../constants";

const steps = ['prospect', 'miniApp', 'quotes', 'fullApp'];
const level = {
  customizeOffer: { title: "Personal loan", step: false, level: 1, disablePopUp: false },
  documentUpload: { backBtnClose: true, step: false, level: 1, toggleContainer: true, removeCard: false, hideBackToAll: true },
  underReview: { backBtnClose: true, step: false, level: 1, toggleContainer: true, removeCard: false, hideBackToAll: true },
  declineOffer: { title: "Personal loan", step: false, backBtnClose: true, closeBtnClose: false, level: 2, disablePopUp: false },
  loanInformation: { title: "Personalize your loan", step: "miniApp", level: 2, disablePopUp: false },
  addBankDetails: { title: "Enter bank details", step: "quotes", level: 3, disablePopUp: false },
  securityCheck: { title: "Verify your identity", step: false, backBtnClose: true, closeBtnClose: false, level: 3, disablePopUp: false },
  authLock: { backBtnClose: true, step: false, level: 3, toggleContainer: true, removeCard: false, topHeader: true },
  bankDetailsConfirm: { title: "Confirm", step: "fullApp", level: 4, disablePopUp: false, hideBackToAll: true, backBtnClose: true },
  confirmBankDetails: { title: "Confirm", step: "fullApp", level: 1, disablePopUp: false, hideBackToAll: true, backBtnClose: true },
  agreement: { title: "Your loan is ready to sign", step: "fullApp", level: 5, disablePopUp: false, backBtnClose: true, hideBackToAll: true },
  congrat: { backBtnClose: true, removeBorder: true, level: 6, disablePopUp: true },
  offerExpired: { backBtnClose: true, closeBtnClose: true, removeBorder: true, step: false, level: 1, disablePopUp: false, hideBackToAll: true }
};
export const updateLevel=(target)=>{
  if(target === "APPROVED"){
    level.bankDetailsConfirm.level=1;
    level.agreement.level=2;
    level.congrat.level=3;
  }else if(target === "DECLINED"){
    level.declineOffer.level=1;
  }else if(target === "UPLOAD_DOCUMENTS"){
    level.bankDetailsConfirm.level=2;
    level.agreement.level=3;
    level.congrat.level=4;
  }
};
const MOBILES=["MOBILE", "MOBILE_ANDROID", "MOBILE_IPHONE"];
const HEADER_CONFIG = {
  MOBILE: MOBILES,
  DISABLED_FEATURE: {
    keys: MOBILES,
    property: { isHeaderHide: true, target: false, extraParam: true, backURL: "uscbapp://OneAppOfferDetails" }
  },
  ENABLED_FAQ: ["CWS", "WEB", "MOBILE_WEB"]
};
export const getHeaderStatus=(channelSource)=>{
  return HEADER_CONFIG.DISABLED_FEATURE.keys.indexOf(channelSource) !== -1;
};
export const isFAQShow=(channelSource)=>{
  return HEADER_CONFIG.ENABLED_FAQ.indexOf(channelSource) !== -1;
};
export const getTeamData=(channelSource)=>{
  return HEADER_CONFIG.DISABLED_FEATURE.keys.indexOf(channelSource) !== -1? HEADER_CONFIG.DISABLED_FEATURE.property:null;
};
export const getLevel=(key)=>{
  return level[key];
};
export const isMobileChannel=(channelSource)=>{
  return HEADER_CONFIG.MOBILE.indexOf(channelSource) !== -1;
};
export const getIntervalConfig=()=>{
  if(window.envConfig && window.envConfig.intervalConfig){
    let config = window.envConfig.intervalConfig;
    const intervalConfig={};
    for(let key in config){
      intervalConfig[key]={
        COUNT: parseInt(config[key].COUNT||DEFAULT_INTERVAL_CONFIG[key].COUNT),
        DELAY: parseInt(config[key].DELAY||DEFAULT_INTERVAL_CONFIG[key].DELAY)
      };
    }
    return intervalConfig;
  }
  return JSON.parse(JSON.stringify(DEFAULT_INTERVAL_CONFIG));

};
const isAfter = (oneStep, anotherStep) =>
  steps.indexOf(oneStep) > steps.indexOf(anotherStep);


export const getUrl=(url, data)=>{
  let urlArray = url.split( '/' );
  urlArray[urlArray.length-1]=data;
  return urlArray.join('/');
};

export const scrollToTop = ()=>{
  return (
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    })
  );
};

export default isAfter;
